const researchImageSlider = new Swiper('.research-image-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20
});

const researchContentSlider = new Swiper('.research-content-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  }
});

 researchContentSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  document.querySelector('.research-button.active').classList.remove('active');
  document.querySelector(`.research-button[data-idx="${idx}"]`).classList.add('active');

  researchImageSlider.slideToLoop(idx);
});

const researchButtons = document.querySelectorAll('.research-button');
 researchButtons.forEach(button => {
  button.addEventListener('click', event => {
    const idx = event.currentTarget.dataset.idx;

    document.querySelector('.research-button.active').classList.remove('active');
    event.currentTarget.classList.add('active');

     researchContentSlider.slideToLoop(idx);
  });
});